import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/render/project/src/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/styles/globals.css");
